// Guarda arquivos do jogo no aparelho (IndexedDB): ROM, save (SRAM) e o estado
// para "continuar de onde parou". Se o IndexedDB não existir (ex.: aba anônima),
// funciona só na memória enquanto a página estiver aberta.

export type StoredFile = 'rom' | 'romMeta' | 'sram' | 'state';

const DB_NAME = 'dynasty-firered';
const STORE = 'files';

let dbPromise: Promise<IDBDatabase | null> | null = null;
const memory = new Map<StoredFile, Uint8Array>();

function openDb(): Promise<IDBDatabase | null> {
  dbPromise ??= new Promise((resolve) => {
    try {
      const request = indexedDB.open(DB_NAME, 1);
      request.onupgradeneeded = () => request.result.createObjectStore(STORE);
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => resolve(null);
      request.onblocked = () => resolve(null);
    } catch {
      resolve(null);
    }
  });
  return dbPromise;
}

async function run<T>(mode: IDBTransactionMode, action: (store: IDBObjectStore) => IDBRequest<T>): Promise<T | null> {
  const db = await openDb();
  if (!db) return null;
  return new Promise((resolve, reject) => {
    const request = action(db.transaction(STORE, mode).objectStore(STORE));
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function loadFile(name: StoredFile): Promise<Uint8Array | null> {
  try {
    const value = await run('readonly', (store) => store.get(name));
    if (value instanceof Uint8Array) return value;
  } catch {
    // cai para a memória
  }
  return memory.get(name) ?? null;
}

export async function saveFile(name: StoredFile, data: Uint8Array): Promise<void> {
  memory.set(name, data);
  try {
    await run('readwrite', (store) => store.put(data, name));
  } catch (error) {
    console.warn(`Não deu para salvar "${name}" no aparelho:`, error);
  }
}

export async function deleteFile(name: StoredFile): Promise<void> {
  memory.delete(name);
  try {
    await run('readwrite', (store) => store.delete(name));
  } catch {
    // nada a fazer
  }
}
